import { useState } from 'react';
import { faqs } from '@/mocks/home';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 tracking-wide">常见问答</h2>
          <p className="mt-2 text-sm text-foreground-500">关于樱花TV的常见问题，快速解答你的疑惑</p>
        </div>
        <div className="max-w-2xl mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggle(i)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
              >
                <h3 className="text-sm font-medium text-foreground-700 pr-4">{faq.q}</h3>
                <i
                  className={`text-foreground-400 transition-transform duration-200 flex-shrink-0 ${
                    openIndex === i ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}